<ng-container *ngIf="viewState$ | async as viewState">
        <ng-container ntapItemProvider ntapItemViewProvider [viewName]="VIEW_user" [viewState]="viewState">
            <p-card [style]="{ width: '800px' } ">
                <ntap-prime-common-itemview></ntap-prime-common-itemview>
            </p-card>
        </ng-container>
</ng-container>